import { lazy } from "react";
import { Helmet } from "react-helmet";
import IntroContent from "../../content/IntroContent.json";
import MiddleBlockContent from "../../content/MiddleBlockContent.json";
import AboutContent from "../../content/AboutContent.json";
import MissionContent from "../../content/MissionContent.json";
import ProductContent from "../../content/ProductContent.json";
import AIOutfitSuggestionsContent from "../../content/AIOutfitSuggestionsContent.json";
import AIItemAnalysisContent from "../../content/AIItemAnalysisContent.json";
import AIWeatherContent from "../../content/AIWeatherContent.json";

const MiddleBlock = lazy(() => import("../../components/MiddleBlock"));
const Container = lazy(() => import("../../common/Container"));
const ScrollToTop = lazy(() => import("../../common/ScrollToTop"));
const ContentBlock = lazy(() => import("../../components/ContentBlock"));

const Home = () => {
  return (
    <Container>
      <Helmet>
        <title>Pureple - #1 AI Outfit Planner & Closet Organizer | Free Fashion App</title>
        <meta name="description" content="Pureple is the #1 AI-powered outfit planner and closet organizer app. Get personalized outfit suggestions, weather-based recommendations, and smart wardrobe management. Free for iOS and Android." />
        <meta name="keywords" content="outfit planner, closet organizer, AI fashion app, wardrobe management, outfit suggestions, weather outfits, virtual stylist, fashion AI, closet app, style planner" />
        <link rel="canonical" href="https://pureple.com" />
        <meta property="og:title" content="Pureple - #1 AI Outfit Planner & Closet Organizer" />
        <meta property="og:description" content="Get personalized AI outfit suggestions from your own closet. Weather-based recommendations, smart wardrobe organization, and virtual styling. Free app for iOS and Android." />
        <meta property="og:url" content="https://pureple.com" />
      </Helmet>
      <ScrollToTop />
      
      <ContentBlock
        type="right"
        title={IntroContent.title}
        content={IntroContent.text}
        callout={IntroContent.callout}
        button={[]}
        icon="waving.svg"
        id="intro"
      />
      
      <ContentBlock
        type="left"
        title={AIOutfitSuggestionsContent.title}
        content={AIOutfitSuggestionsContent.text}
        button={AIOutfitSuggestionsContent.button}
        icon="graphs.svg"
        id="ai-outfits"
      />
      
      <ContentBlock
        type="right"
        title={AIItemAnalysisContent.title}
        content={AIItemAnalysisContent.text}
        button={AIItemAnalysisContent.button}
        icon="product-launch.svg"
        id="ai-analysis"
      />
      
      <ContentBlock
        type="left"
        title={AIWeatherContent.title}
        content={AIWeatherContent.text}
        button={AIWeatherContent.button}
        icon="waving.svg"
        id="ai-weather"
      />

      <MiddleBlock
        title={MiddleBlockContent.title}
        content={MiddleBlockContent.text}
        button={MiddleBlockContent.button}
      />
      
      <ContentBlock
        type="left"
        title={AboutContent.title}
        content={AboutContent.text}
        section={AboutContent.section}
        icon="graphs.svg"
        id="about"
      />
      
      <ContentBlock
        type="right"
        title={MissionContent.title}
        content={MissionContent.text}
        icon="product-launch.svg"
        id="mission"
      />
      
      <ContentBlock
        type="left"
        title={ProductContent.title}
        content={ProductContent.text}
        icon="waving.svg"
        id="product"
      />
    </Container>
  );
};

export default Home;
